import { FC } from 'react';
import { UserTournamentsSectionFragment } from '@/__generated__/graphql.ts';
import { Award } from '@/components/award/award.tsx';
import * as medalsStyles from './medal-block.css.ts';
import * as tournamentsStyles from './tournaments-section.css.ts';

export const MedalsBlock = ({
  medals,
}: {
  medals: UserTournamentsSectionFragment['medals'];
}) => {
  return (
    <div className={tournamentsStyles.medalsContainer}>
      {medals.map(({ medal, tournaments }) => (
        <MedalItem
          key={medal.id}
          medalId={medal.id}
          quantity={tournaments.length}
        />
      ))}
    </div>
  );
};

interface MedalBlockProps {
  medalId: string;
  quantity: number;
}

export const MedalItem: FC<MedalBlockProps> = ({ medalId, quantity }) => {
  return (
    <div className={medalsStyles.medalsContainer}>
      <Award medalId={medalId} />
      <span className={medalsStyles.quantity}>x{quantity}</span>
    </div>
  );
};
